import { render, staticRenderFns } from "./DndDialog.vue?vue&type=template&id=3a59e67e&scoped=true&lang=pug&"
import script from "./DndDialog.vue?vue&type=script&lang=js&"
export * from "./DndDialog.vue?vue&type=script&lang=js&"
import style0 from "./DndDialog.vue?vue&type=style&index=0&id=3a59e67e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a59e67e",
  null
  
)

export default component.exports